export class DeleteItemService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(data) {
    return await this.httpClient.post('/pedidos/ExcluiPedido/', data)
  }
}
